import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { stepEightValidationSchema } from '../../utils/validation';
import PhoneController from '../../components/common/controller/PhoneController';
import { resetJobForm } from '../../redux/slice/findJobSlice';
import { fetchCountries } from '../../redux/action/commonAction';
import { handleCreateDeveloper } from '../../redux/action/findJobAction';
import Button from '../../components/general/Button';
import { setShowSuccessModal } from '../../redux/slice/commonSlice';
import Input from '../../components/general/Input';
import Select from '../../components/general/Select';

const StepEightForm = () => {
    const dispatch = useDispatch();
    const {
        stepTwoData,
        stepOneData: { availability },
        stepThreeData: { seniority, specialization },
        stepFourData: { total_experience },
        stepFiveData: { experience },
        stepSixData: { cv_id, linkedin_url, link_to_cv },
        stepSevenData,
        stepEightData: { countries, isCountryLoading, ...rest }
    } = useSelector(state => state.findJob);

    const { reset, control, register, handleSubmit, formState: { errors, isValid }, setValue } = useForm({
        mode: "all",
        defaultValues: rest,
        resolver: yupResolver(stepEightValidationSchema)
    });

    useEffect(() => {
        if (!isCountryLoading) return;
        dispatch(fetchCountries());
        // eslint-disable-next-line
    }, [isCountryLoading])

    const handleFormSubmit = (data) => {
        const { agree, ...rest } = data;
        // dispatch(setFormData({ formData: rest }));
        const formData = {
            ...stepTwoData,
            seniority,
            specialization,
            ...stepSevenData,
            ...rest,
            availability: availability !== "None" ? availability : null,
            ...(cv_id && { resume: cv_id }),
            ...((linkedin_url || link_to_cv) && { resume_url: linkedin_url || link_to_cv }),
            ...(total_experience && { total_experience: new Date().getFullYear() - total_experience }),
            ...(Object.keys(experience || {}).length && {
                skills_experiences: Object.keys(experience).map(key => ({ skill: key, experience: experience[key] }))
            }),
        }
        dispatch(handleCreateDeveloper(formData)).then((status) => {
            if (status === 201) {
                reset();
                dispatch(resetJobForm())
                dispatch(setShowSuccessModal(true))
            }
        })
    }
    
    return (
        <div className='min-h-[60vh] !py-[50px] !pb-[60px] lg:flex lg:justify-between'>
            <div className='lg:w-[40%]'>
                <div>
                    <p className='text-primary-color'> 8/8 </p>
                    <h1 className="text-[1.6rem] font-semibold">
                        <span> Submit your application to </span>
                        {/* <Image src={DoubleStar} alt="double-star" className="hidden lg:inline-block" /> */}
                        <span className='lg:block'> Devhire </span>
                    </h1>
                </div>
            </div>

            <div className='lg:w-[55%]'>
                <div className='hidden lg:flex gap-[20px] text-[13px] mb-[30px] lg:justify-center'>
                    <p className='text-primary-color'> 1. Project Preferences </p>
                    <p className='text-primary-color'> 2. Specialization in stack </p>
                    <p className='text-primary-color'> 3. Additional info </p>
                    <p className='text-primary-color'> 4. Registration </p>
                </div>

                <div className='text-[15px] mb-[30px]'>
                    <div className='flex items-start lg:justify-center gap-[10px] text-[#797979] mt-[20px]'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 hidden lg:block">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>

                        <div className='text-left lg:text-center'>
                            Great job! Now we need the final details to create an account for you and guide you on the
                            next steps.
                        </div>
                    </div>
                </div>
                <div className='flex flex-col md:grid md:grid-cols-2 gap-4 mt-[20px] w-full'>
                    <Input 
                        name="first_name" 
                        register={register} 
                        placeholder='First Name' 
                        type="text" 
                        className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]' 
                        error={errors.first_name?.message}
                    />

                    <Input 
                        name="email" 
                        register={register} 
                        placeholder='Email' 
                        type="text" 
                        className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]' 
                        error={errors.email?.message}
                    />
                    
                    <Input 
                        name="last_name" 
                        register={register} 
                        placeholder='Last Name' 
                        type="text" 
                        className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]' 
                        error={errors.last_name?.message}
                    />

                    <Select 
                        name="country"
                        options={countries}
                        onChange={(value) => {
                            setValue("country", value)
                        }}
                        defaultValue={{
                            label: "United States",
                            value: 2
                        }}
                    />
                    
                    <div className='lg:col-span-2'>
                        <PhoneController
                            name={"mobile"}
                            control={control}
                            placeholder="Phone Number (Optional)"
                            error={errors.mobile?.message}
                        />
                    </div>
                </div>
                <div className="terms mt-[20px]">
                    <div className="flex items-center justify-start">
                        <input type="checkbox" id="agree" className='terms accent-primary-color' {...register("agree")} />
                        <label htmlFor="agree" className='font-extralight text-[13px] ml-[10px]'>
                            By registering, I agree to the. See the for information on our privacy practices.
                        </label>
                    </div>
                    <p className='text-red-500 text-[12px] mt-[10px]'>{errors.agree?.message}</p>
                </div>
                <Button onClick={() => handleSubmit(handleFormSubmit)()} disabled={!isValid} className='w-full bg-primary-color text-black h-[40px] lg:h-[50px] text-[18px] lg:text-[20px] lg:mx-auto rounded mt-[20px] md:w-[200px] lg:mt-[50px]'>Ok, next <i className="fa-solid fa-arrow-up-right" /></Button>
            </div>
        </div>
    )
}

export default StepEightForm